import questionnaire from '../Questions.json';

function toSurveryData(data) {
  const restored = {};
  const hasValue = value => value !== null && value !== undefined;
  function visit(node) {
    if (!node || typeof node !== 'object') return;
    if (node.type === 'matrix') {
      const values = {};
      (node.rows || []).forEach(row => {
        const key = typeof row === 'string' ? row : row.value;
        const value = data[key];
        if (hasValue(value)) values[key] = value;
      });
      if (Object.keys(values).length) restored[node.name] = values;
    } else if (node.name && hasValue(data[node.name])) {
      restored[node.name] = data[node.name];
    }
    ['pages', 'elements'].forEach(key => (node[key] || []).forEach(visit));
  }
  visit(questionnaire);
  return restored;
}

export default toSurveryData;

